/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomFieldsSchemaDto } from '../../models/custom-fields-schema-dto';
import { UpdateCurrentCustomFieldsSchemaRequest } from '../../models/update-current-custom-fields-schema-request';

export interface UpdateCurrentCustomFieldsSchema$Params {
  id: string;
      body: UpdateCurrentCustomFieldsSchemaRequest
}

export function updateCurrentCustomFieldsSchema(http: HttpClient, rootUrl: string, params: UpdateCurrentCustomFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomFieldsSchemaDto>> {
  const rb = new RequestBuilder(rootUrl, updateCurrentCustomFieldsSchema.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomFieldsSchemaDto>;
    })
  );
}

updateCurrentCustomFieldsSchema.PATH = '/v0/CustomFieldsSchema/{id}/current';
